import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ManageContractTypeHistoryComponent } from './manage-contract-type-history.component';

const routes: Routes = [
  {
    path: '',
    component: ManageContractTypeHistoryComponent,
    data: { title: 'Manage Contract Type History' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageContractTypeHistoryRoutingModule {}

@NgModule({
  imports: [
    ManageContractTypeHistoryRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [ManageContractTypeHistoryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageContractTypeHistoryModule {}
